module.exports = __webpack_public_path__ + "media/derect_tutorial_zoek_een_invalkracht.df758f15.mp4";